import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgComponent = ({ title, titleId, ...props }) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	width: 24,
	height: 25,
	viewBox: "0 0 24 25",
	stroke: "#595959",
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("path", {
			d: "M8.5 4.75h7a4 4 0 0 1 4 4v15.5h-15V8.75a4 4 0 0 1 4-4Z",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: 1.5,
			clipRule: "evenodd"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M9 4.75a2.792 2.792 0 0 1 2.935-3 2.815 2.815 0 0 1 2.935 3",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: 1.5
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M2.707 15.25H4.5v9H2.707A1.957 1.957 0 0 1 .75 22.293v-5.086c0-1.08.876-1.957 1.957-1.957Zm16.793.196h1.793c1.08 0 1.955.874 1.957 1.954v4.891a1.957 1.957 0 0 1-1.957 1.957H19.5v-8.802Zm-12 .054a1 1 0 0 1 1-1h7a1 1 0 0 1 1 1v4.75a1 1 0 0 1-1 1h-7a1 1 0 0 1-1-1V15.5Z",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: 1.5,
			clipRule: "evenodd"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M7.5 17.5h9m-3.75 0V19m-12-.815H4.5m15 .065h3.75",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: 1.5
		})
	]
});
export const ReactComponent = SvgComponent;
export default "data:image/svg+xml,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20fill%3D%22none%22%20width%3D%2224%22%20height%3D%2225%22%20viewBox%3D%220%200%2024%2025%22%20stroke%3D%22%23595959%22%3E%3Cpath%20d%3D%22M8.5%204.75h7a4%204%200%200%201%204%204v15.5h-15V8.75a4%204%200%200%201%204-4Z%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%20stroke-width%3D%221.5%22%20clip-rule%3D%22evenodd%22%2F%3E%3Cpath%20d%3D%22M9%204.75a2.792%202.792%200%200%201%202.935-3%202.815%202.815%200%200%201%202.935%203%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%20stroke-width%3D%221.5%22%2F%3E%3Cpath%20d%3D%22M2.707%2015.25H4.5v9H2.707A1.957%201.957%200%200%201%20.75%2022.293v-5.086c0-1.08.876-1.957%201.957-1.957Zm16.793.196h1.793c1.08%200%201.955.874%201.957%201.954v4.891a1.957%201.957%200%200%201-1.957%201.957H19.5v-8.802Zm-12%20.054a1%201%200%200%201%201-1h7a1%201%200%200%201%201%201v4.75a1%201%200%200%201-1%201h-7a1%201%200%200%201-1-1V15.5Z%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%20stroke-width%3D%221.5%22%20clip-rule%3D%22evenodd%22%2F%3E%3Cpath%20d%3D%22M7.5%2017.5h9m-3.75%200V19m-12-.815H4.5m15%20.065h3.75%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%20stroke-width%3D%221.5%22%2F%3E%3C%2Fsvg%3E";
